import Revenues_RevenuesPage from "@Quest/Financials/Revenues/Pages/RevenuesPage.vue";
import Capex_CapexPage from "@Quest/Financials/Capex/Pages/CapexPage.vue";
import Costs_CostsPage from "@Quest/Financials/Costs/Pages/CostsPage.vue";

export const routes = [
    {
        path: "/enterprise/revenues/:workspaceId/:strategyId",
        component: Revenues_RevenuesPage
    },

    {
        path: "/enterprise/costs/:workspaceId/:strategyId",
        component: Costs_CostsPage
    },

    {
        path: "/enterprise/capex/:workspaceId/:strategyId",
        component: Capex_CapexPage
    },
]
